import React from 'react';

import { func_validation, func_datetime } from 'functions';

export const loggingColumns = {
    // Columns Array
    getColumns,

    // Columns
    getColumns_username,
    getColumns_date,
    getColumns_msg,
}

function getColumns() {
    return [
        getColumns_username(),
        getColumns_date(),
        getColumns_msg(),
    ];
}

function getColumns_username() {
    let columnClassName = "logging-tableColumn-username";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Username",
        id: "username",
        accessor: "UserName",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let value = func_validation.getTableCellValue_string(props, "");
            let isSubrow = func_validation.isTableRowIndexSubrow(props);

            return isSubrow? "":(
                <div className={"noWrap-text-ellipsis"}>{value}</div>
            );
        },
    }
}

function getColumns_date() {
    let columnClassName = "logging-tableColumn-date";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Date",
        id: "date",
        accessor: "Date",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let value_formatted = func_validation.getTableCellValue_string(props, "-");

            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            let isSubrow = func_validation.isTableRowIndexSubrow(props);
            if (isSubrow) return "";
            
            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_msg() {
    let columnClassName = "logging-tableColumn-msg";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Message",
        id: "message",
        accessor: "Message",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let value = func_validation.getTableCellValue_string(props, "");
            let isSubrow = func_validation.isTableRowIndexSubrow(props);

            if (isSubrow) return value;

            return (
                <div className={"noWrap-text-ellipsis"}>{value}</div>
            );
        },
    }
}